/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProductsqueryCategoriesGet } from '../fn/categories/api-productsquery-categories-get';
import { ApiProductsqueryCategoriesGet$Params } from '../fn/categories/api-productsquery-categories-get';
import { apiProductsqueryCategoriesGet$Plain } from '../fn/categories/api-productsquery-categories-get-plain';
import { ApiProductsqueryCategoriesGet$Plain$Params } from '../fn/categories/api-productsquery-categories-get-plain';
import { apiProductsqueryCategoriesHighlightedGet } from '../fn/categories/api-productsquery-categories-highlighted-get';
import { ApiProductsqueryCategoriesHighlightedGet$Params } from '../fn/categories/api-productsquery-categories-highlighted-get';
import { apiProductsqueryCategoriesHighlightedGet$Plain } from '../fn/categories/api-productsquery-categories-highlighted-get-plain';
import { ApiProductsqueryCategoriesHighlightedGet$Plain$Params } from '../fn/categories/api-productsquery-categories-highlighted-get-plain';
import { Category } from '../models/category';
import { CategoryFlat } from '../models/category-flat';

@Injectable({ providedIn: 'root' })
export class CategoriesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProductsqueryCategoriesGet()` */
  static readonly ApiProductsqueryCategoriesGetPath = '/api/productsquery/categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryCategoriesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryCategoriesGet$Plain$Response(params?: ApiProductsqueryCategoriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Category>>> {
    return apiProductsqueryCategoriesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryCategoriesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryCategoriesGet$Plain(params?: ApiProductsqueryCategoriesGet$Plain$Params, context?: HttpContext): Observable<Array<Category>> {
    return this.apiProductsqueryCategoriesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Category>>): Array<Category> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryCategoriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryCategoriesGet$Response(params?: ApiProductsqueryCategoriesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Category>>> {
    return apiProductsqueryCategoriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryCategoriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryCategoriesGet(params?: ApiProductsqueryCategoriesGet$Params, context?: HttpContext): Observable<Array<Category>> {
    return this.apiProductsqueryCategoriesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Category>>): Array<Category> => r.body)
    );
  }

  /** Path part for operation `apiProductsqueryCategoriesHighlightedGet()` */
  static readonly ApiProductsqueryCategoriesHighlightedGetPath = '/api/productsquery/categories/highlighted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryCategoriesHighlightedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryCategoriesHighlightedGet$Plain$Response(params?: ApiProductsqueryCategoriesHighlightedGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryFlat>>> {
    return apiProductsqueryCategoriesHighlightedGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryCategoriesHighlightedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryCategoriesHighlightedGet$Plain(params?: ApiProductsqueryCategoriesHighlightedGet$Plain$Params, context?: HttpContext): Observable<Array<CategoryFlat>> {
    return this.apiProductsqueryCategoriesHighlightedGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CategoryFlat>>): Array<CategoryFlat> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryCategoriesHighlightedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryCategoriesHighlightedGet$Response(params?: ApiProductsqueryCategoriesHighlightedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryFlat>>> {
    return apiProductsqueryCategoriesHighlightedGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryCategoriesHighlightedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryCategoriesHighlightedGet(params?: ApiProductsqueryCategoriesHighlightedGet$Params, context?: HttpContext): Observable<Array<CategoryFlat>> {
    return this.apiProductsqueryCategoriesHighlightedGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CategoryFlat>>): Array<CategoryFlat> => r.body)
    );
  }

}
